// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connectFolderPre {
  background-color: #eee;
  border-radius: 4px;
  border: 2px solid #ddd;
  padding: 1rem;
}

.connectFolderInput {
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  gap: 4px;

  input {
    padding: 0.5rem;
  }
}

.connectFolderRadioGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
}

.connectFolderNote {
  margin: 0.5rem 0 0;
  color: #555;
  font-size: 0.9em;
}

.connectedFolderList {
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > form {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 12px 10px;
    margin: 0;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;

      & button {
        justify-self: start;
      }
    }
  }

  & input {
    padding: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/ConnectFolder.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,QAAQ;;EAER;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;IACE,aAAa;IACb,mCAAmC;IACnC,cAAc;IACd,SAAS;;IAET;MACE,0BAA0B;;MAE1B;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".connectFolderPre {\n  background-color: #eee;\n  border-radius: 4px;\n  border: 2px solid #ddd;\n  padding: 1rem;\n}\n\n.connectFolderInput {\n  display: flex;\n  flex-direction: column;\n  margin: 1rem 0;\n  gap: 4px;\n\n  input {\n    padding: 0.5rem;\n  }\n}\n\n.connectFolderRadioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n  }\n}\n\n.connectFolderNote {\n  margin: 0.5rem 0 0;\n  color: #555;\n  font-size: 0.9em;\n}\n\n.connectedFolderList {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  & > form {\n    display: grid;\n    grid-template-columns: 1fr 1fr auto;\n    gap: 12px 10px;\n    margin: 0;\n\n    @media (max-width: 600px) {\n      grid-template-columns: 1fr;\n\n      & button {\n        justify-self: start;\n      }\n    }\n  }\n\n  & input {\n    padding: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
